"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotCheckCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotCheckCircle = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#check_circle_spot_56_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M6.8 24.892C9.233 17.77 17.882 11.19 25.522 8.66c7.675-2.545 16.77-.506 22.796 5.444s8.963 14.856 7.15 22.358c-1.764 7.524-8.06 12.05-13.602 14.815-5.576 2.78-10.398 2.79-16.153 1.397-5.772-1.343-11.621-3.558-14.627-8.765C8.081 38.7 4.332 32.029 6.8 24.892Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M37.301 21 24.468 33.833 18.635 28m32.666.002c0 12.887-10.446 23.334-23.333 23.334-12.886 0-23.333-10.447-23.333-23.334 0-12.886 10.447-23.333 23.333-23.333 12.887 0 23.333 10.447 23.333 23.333Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "check_circle_spot_56_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  }))));
};
exports.SpotCheckCircle = SpotCheckCircle;
SpotCheckCircle.displayName = "SpotCheckCircle";